import React from 'react';

import { TCommonProps, TForwardedRef } from 'types/gridDefs';

import { DataGridBase } from './DataGrid/DataGrid.Base';
import { ErrorBoundary } from './Error/ErrorBoundary';

/* ======================================== */

type TProps = TCommonProps;

/* ======================================== */

/**
 * Standard adserve DataGrid
 * !! prototype: still under development !!
 * @public
 */
export const AsDataGridSimple = React.forwardRef<TForwardedRef, TProps>((props, forwardedRef) => {
    return (
        <ErrorBoundary name='AsDataGridSimple'>
            <DataGridBase
                {...props}
                ref={forwardedRef}
            />
        </ErrorBoundary>
    );
});
